import React, { useState, useEffect } from 'react'
import api from '../../components/api'

import Table from 'react-bootstrap/Table'

import { useEnergiaHvacContext } from '../../context/energiaHvacContext'
import { useEnergiaHvacIndiretaContext } from '../../context/energiaHvacIndiretaContext'
import { useEnergiaHvacDiretaContext } from '../../context/energiaHvacDiretaContext'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'


import { Link } from 'react-router-dom'
import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'


import StatusValidacaoSecao from '../StatusValidacaoSecao';



const HVAC = (props) => {


    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    var ano = props.ano
    var energia_id = props.energia_id   


    const { energiaHvac_id, setEnergiaHvac_id } = useEnergiaHvacContext()


    const [resultadoHvac, setResultadoHvac] = useState()
    
    const [resultadoExpansaoDireta, setResultadoExpansaoDireta] = useState()
    const [resultadoExpansaoIndireta, setResultadoExpansaoIndireta] = useState()
    const { energiaHvacExpansaoIndireta_id, setEnergiaHvacExpansaoIndireta_id } = useEnergiaHvacIndiretaContext()

    const { energiaHvacExpansaoDireta_id, setEnergiaHvacExpansaoDireta_id } = useEnergiaHvacDiretaContext()
    

    const [informa, setInforma] = useState(true)

    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao1, setQuestao1] = useState()
    const [questao2, setQuestao2] = useState()
    const [questao3, setQuestao3] = useState()

    const [totalPendencias, setTotalPendencias] = useState(0)



    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        setQuestao2()
        setQuestao3()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'HVAC - Equipamento Unitário':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break

                            case 'HVAC - Sistema Central - Expansão Indireta (CAG-Chiller)':

                                totalErros = totalErros + 1
                                setQuestao2('red')
    
                            break

                            case 'HVAC - Sistema Central - Expansão Direta':

                                totalErros = totalErros + 1
                                setQuestao3('red')
    
                            break

                            
                        }

                    }
                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }




    function consultaHvac() {

        api.get(`energiaHvacListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)

            setResultadoHvac(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalEnergiaHVACUnitario').modal('show');setEnergiaHvac_id(rs.energiaHvac_id)}}>
                    <td>
                        {rs.tipo}
                    </td>
                    <td>
                        {rs.marca}
                    </td>
                    <td style={{ textAlign: 'right'}}>
                        {rs.quantidade}
                    </td>
                    <td>
                        {rs.identificacao}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    


    function consultaHvacExpansaoIndireta() {

        api.get(`energiaHvacExpansaoIndiretaListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)
            setResultadoExpansaoIndireta(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalHVACIndireta').modal('show');setEnergiaHvacExpansaoIndireta_id(rs.energiaHvacExpansaoIndireta_id)}}>
                    <td >
                        {rs.tipoChiller}
                    </td>
                    <td>
                        {rs.marcaChiller}
                    </td>
                    <td style={{ textAlign: 'right'}}>
                        {rs.quantidadeChiller}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

        
    }




    function consultaHvacExpansaoDireta() {


        api.get(`energiaHvacExpansaoDiretaListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)

            setResultadoExpansaoDireta(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalHVACDireta').modal('show');setEnergiaHvacExpansaoDireta_id(rs.energiaHvacExpansaoDireta_id)}}>
                    <td>
                        {rs.tipoEquipamento}
                    </td>
                    <td>
                        {rs.marcaChillerDireta}
                    </td>
                    <td style={{ textAlign: 'right'}}>
                        {rs.quantidadeChillerDireta}
                    </td>
                </tr>
            
            ))
            

        }).catch((err) => {

            console.log(err.response)

        })


    }




    useEffect(() => {

        var dataPost = {

            tipo: 'informaHVAC',
            informa: informa,

        }

        api.post(`energiaInforma/${energia_id}`, dataPost).then((result) => {

            console.log(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }, [informa])



    const consultaInforma = () => {

        api.get(`energiaInforma/${energia_id}/informaHVAC`).then((result) => {

            
            setInforma(result.data[0].informaHVAC)

        }).catch((err) => {

            console.log(err.response)

        })
    }




    useEffect(() => {

        consultaHvac()
        
        consultaHvacExpansaoIndireta()
        consultaHvacExpansaoDireta()
        consultaInforma()
        

    }, [ano, energia_id, atualizacaoGestao])

    

    return (
        <div>


            <div className="col-md-12">
                <div align="left">

                
                    <select className="form-control" value={informa} onChange={event => setInforma(event.target.value)}>
                        <option value={true}>A instituição possui o(s) equipamento(s) e reportará suas informações</option>
                        <option value={false}>A instituição não possui o(s) equipamento(s) ou a instituição possui o(s) equipamento(s) mas não reportará suas informações</option>
                    </select>
                    <br/>

                </div>
            </div>

            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                    
                    <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('HVAC - Equipamento Unitário');setSecaoEnunciado('HVAC');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade para Equipamento Unitário]</Link>
                    <br/><br/>
                    
    
                    
                    <button type="button" className="btn btn-primary" onClick={() => {window.$('#modalEnergiaHVACUnitario').modal('show');setEnergiaHvac_id()}} >+ Adicionar Equipamento Unitário</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>

                


                <Table striped bordered hover>

                    <thead>

                        <tr>
                            <th colspan="4">
                            Equipamento Unitário
                            </th>
                        </tr>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Quantidade

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Ambiente

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoHvac}
                    </tbody>

                </Table>

            </div>



            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                    <br/>
                    <Link to='#' style={{ color: questao2 }} onClick={() => {setEnunciado('HVAC - Sistema Central - Expansão Indireta (CAG-Chiller)');setSecaoEnunciado('HVAC');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade para Sistema Central - Expansão Indireta (CAG-Chiller)]</Link>
                    <br/><br/>
                    
                    <button type="button" className="btn btn-warning" onClick={() => {window.$('#modalHVACIndireta').modal('show');setEnergiaHvac_id()}} >+ Adicionar Sistema Central - Expansão Indireta (CAG-Chiller)</button>
                    <br/><br/>
                

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>

                


                <Table striped bordered hover>

                    <thead>

                        <tr>
                            <th colspan="3">
                            Sistema Central - Expansão Indireta (CAG-Chiller)
                            </th>
                        </tr>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Quantidade

                            </th>
                          
                        </tr>
                    </thead>
                    <tbody>
                        {resultadoExpansaoIndireta}
                    </tbody>

                </Table>

            </div>



            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                    <br/>
                    <Link to='#' style={{ color: questao3 }} onClick={() => {setEnunciado('HVAC - Sistema Central - Expansão Direta');setSecaoEnunciado('HVAC');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade para Sistema Central - Expansão Direta]</Link>
                    <br/><br/>
                    <button type="button" className="btn btn-info" onClick={() => {window.$('#modalHVACDireta').modal('show');setEnergiaHvac_id()}}  >+ Adicionar Sistema Central - Expansão Direta</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>

                


                <Table striped bordered hover>

                    <thead>

                        <tr>
                            <th colspan="3">
                            Sistema Central - Expansão Direta
                            </th>
                        </tr>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Quantidade

                            </th>
                            
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoExpansaoDireta}
                    </tbody>

                </Table>

            </div>






            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoHVAC" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="HVAC" ano={ano} />


        </div>
    )


}

export default HVAC